export default __webpack_public_path__ + "static/media/bb_guess_3.5c4deaee.png";